
export default function Motion() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th />
          <th> non-directional </th>
          <th> directional impf. </th>
          <th> perfective </th>
        </tr>
        <tr>
          <th> to go (by foot) </th>
          <td> hoditi </td>
          <td> idti </td>
          <td> pojdti </td>
        </tr>
        <tr>
          <th> to by (by transport) </th>
          <td> jezditi </td>
          <td> jehati </td>
          <td> pojehati </td>
        </tr>
        <tr></tr>
        <tr>
          <th> to fly </th>
          <td> lětati </td>
          <td> letiti </td>
          <td> poletiti </td>
        </tr>
        <tr>
          <th> to run </th>
          <td> běgati </td>
          <td> běgti </td>
          <td> poběgti </td>
        </tr>
        <tr>
          <th> to climb </th>
          <td> laziti </td>
          <td> lězti </td>
          <td> polězti </td>
        </tr>
        <tr>
          <th> to crawl </th>
          <td> polzati </td>
          <td> polzti </td>
          <td> popolzti </td>
        </tr>
        <tr>
          <th> to swim </th>
          <td> plavati </td>
          <td> plyvti </td>
          <td> poplyvti </td>
        </tr>
        <tr>
          <th> to sail </th>
          <td> plavati </td>
          <td> pluti </td>
          <td> popluti </td>
        </tr>
        <tr>
          <th> to fall </th>
          <td> padati </td>
          <td> pasti </td>
          <td> upasti </td>
        </tr>
        <tr>
          <th> to carry </th>
          <td> nositi </td>
          <td> nesti </td>
          <td> ponesti </td>
        </tr>
        <tr>
          <th> to transport </th>
          <td> voziti </td>
          <td> vezti </td>
          <td> povezti </td>
        </tr>
        <tr>
          <th> to lead </th>
          <td> voditi </td>
          <td> vesti </td>
          <td> povesti </td>
        </tr>
      </tbody>
    </table>
  )
}
